export enum NotificationAlertType {
  Discreet = 0,
  Popup = 1,
}
